import { createStyles, rem } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  title: {
    fontFamily: "Inter",
    fontSize: rem(18),
    fontWeight: 600,
    marginTop: rem(20),
  },
  header: {
    border: "10px solid #f1f3f5",
    paddingTop: rem(10),
  },
  headerTitle: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: rem(10),
    margin: rem(40),
  },
  select: {
    fontFamily: "Inter",
    "& .mantine-Select-wrapper": {
      marginTop: "6px",
      height: "auto",
      backgroundColor: "#FFFFFF",
      borderRadius: "8px",
      border: "1px solid #E5E5E5",
      boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
    },
    "& input": {
      border: "none",
      backgroundColor: "transparent",
      paddingBlock: "10px",
      paddingLeft: "14px",
      height: "44px",
    },
    "& .mantine-Select-rightSection": {
      width: "fit-content",
      height: "inherit",
      marginRight: "14px",
    },
  },
  input: {
    "& .mantine-Input-wrapper": {
      height: "auto",
      backgroundColor: "#FFFFFF",
      borderRadius: "8px",
      border: "1px solid #E5E5E5",
      boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
      "& .mantine-Input-input": {
        fontFamily: "Inter",
        border: "none",
        backgroundColor: "transparent",
        padding: "10px 14px",
        height: "44px",
        fontFamily: "Inter",
      },
    },
    "& .mantine-InputWrapper-label": {
      color: "#262626",
      marginBottom: "6px",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: 500,
    },
  },
  supportDetailRightButtons: {
    background: "transparent",
    // height: "100px",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    margin: "0 5px",
    gap: "10px",
  },
  keyStepsBox: {
    width: "100%",
    height: "100%",
    borderRadius: "8px",
    border: "1px solid #E5E5E5",
    background: "#FCFCFC",
    paddingBottom: "12px",
  },
  keyStepsText: {
    background: "#e5e5e5",
    marginBottom: "14px",
    padding: "8px 18px",
  },
  supportDetailAdditionButton: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",

    // marginRight: "250px",
  },

  headerContent: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "24px",
    padding: "14px 12px",
    width: "100%",
    borderRadius: "12px",
    border: "1px solid #E5E5EA",
    background: "#FFF",
    "& img": {
      width: rem(30),
    },
    "& > div": {
      flex: 1,
    },
    "@media (max-width: 1024px)": {
      gap: rem(30),
    },
    "@media (max-width: 600px)": {
      flexDirection: "column",
      "& > div": {
        width: "100%",
        flex: "unset",
      },
    },
  },
  bodyContent: {
    width: "100%",
    fontFamily: "Inter",
    marginTop: "22px",
    "& img": {
      width: rem(30),
    },
  },
  supportPlaneTopSection: {
    paddingBottom: 30,
    display: "flex",
    gap: 20,
    alignItems: "center",
    justifyContent: "space-around",
    paddingInline: 30,
    "@media (max-width: 600px)": {
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      paddingInline: 0,
      gap: 10,
    },
  },
  outcomeDeleteBTN: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    borderRadius: "8px",
    background: "#FAFAFA",
    padding: "8px",
    "& .mantine-Button-root": {
      display: "flex",
      alignItems: "center",
      background: "transparent",
      padding: "8px 0px",
      width: "auto",
      height: "auto",
      "& .mantine-Button-label": {
        display: "flex",
        alignItems: "center",
        fontWeight: 600,
        gap: 4,
        fontSize: "16px",
        color: "#F04438",
        fontFamily: "Inter",
      },
    },
  },
  activitiesBox: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    borderRadius: "8px",
    border: "1px solid #E5E5E5",
    background: "#FCFCFC",
    overflow: "hidden",
    // background: "red",
    "@media (max-width: 600px)": {
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      paddingInline: 0,
      gap: 0,
    },
  },
  activityBoxHeader: {
    width: "100%",
    display: "flex",
    background: "#E5E5E5",
    padding: "8px 18px",
    justifyContent: "space-between",
    alignItems: "center",
    "& p": {
      color: "#262626",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: 600,
      margin: 0,
    },
  },
  activityFields: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "14px",
    padding: "14px 20px 12px 20px",
  },
  activityInputs: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-evenly",
    gap: "14px",
    "@media (max-width: 600px)": {
      "& .textArea": {
        width: "100%",
      },
    },
  },
  // activitiesTextBox: {
  //   width: "34%",
  //   "@media (max-width: 600px)": {
  //     width: "100%",
  //   },
  // },
  outcomeNumberSection: {
    display: "flex",
    gap: "5px",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "35px",
  },
  buttonBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "1rem",
    margin: "2rem auto",
  },

  textInputBox: {
    width: "100%",
    border: "1px solid rgba(0,0,0,0.1)",
    padding: "5px 15px",
    borderRadius: "15px",
    position: "relative",
    "& textarea[disabled]": {
      backgroundColor: "#fff !important",
    },
    "& .mantine-Textarea-input": {
      border: "none",
      paddingInline: "0",
    },
    "& .label": {
      position: "absolute",
      top: -10,
      left: 15,
      zIndex: 100,
      color: "#000",
      margin: 0,
      backgroundColor: "#fff",
      display: "inline-block",
      fontSize: "14px",
      fontWeight: 500,
      paddingInline: "10px",
    },
  },
  frequencyAndByWhen: {
    width: "100%",
    display: "flex",
    gap: "36px",
    justifyContent: "space-between",
    alignItems: "baseline",
    "@media (max-width:768px)": {
      flexDirection: "column",
      gap: 14,
      "& > div": {
        width: "100%",
      },
    },
  },
  byWhenDateElem: {
    marginTop: "15px",
  },
  essentialSupportRadio: {
    padding: "14px",
    width: "292px",
    borderRadius: "8px",
    border: "1px solid #E5E5E5",
    background: "#FFF",
    "& .mantine-Radio-root": {
      flex: 1,
    },
    "& .mantine-Radio-body .mantine-Radio-label": {
      paddingLeft: "8px",
      color: "#000",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: 500,
    },
  },
  essentialSupportFieldBox: {
    borderRadius: "12px",
    border: "1px solid #E5E5EA",
    background: "#FFF",
    padding: "14px 12px",
  },
  // segment: {
  //   "& .mantine-p2ocmu": {
  //     borderRadius: "1rem 0 0 1rem !important",
  //   },
  // },
  essentialActivities: {
    border: "1px solid rgba(0,0,0,0.1)",
    width: "100%",
    height: "auto",
    borderRadius: "5px",
  },
  oneA: {
    backgroundColor: "#e5e5e5",
    padding: "5px 15px",
  },
  statementAndSupport: {
    padding: "10px 15px",
    backgroundColor: "#fcfcfc",
  },
  statementSupportParent: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    "@media (max-width:992px)": {
      display: "block",
      textAlign: "-webkit-center",
    },
  },
  statementSupportTextArea: {
    width: "100%",
    backgroundColor: "#fcfcfc",
    borderRadius: "5px",
  },
  supportBox: {
    width: "100%",
    "@media (max-width:992px)": {
      width: "100%",
      textAlign: "start",
    },
  },
  instructionsBox: {
    "@media (max-width:992px)": {
      marginTop: "10px",
    },
  },
  addSupportDetails: {
    width: "100%",
    backgroundColor: "#000000",
    color: "#ffffff",
    borderRadius: "5px",
    fontSize: "small",
    marginTop: "10px",
    padding: "10px 0",
    border: "none",
    cursor: "pointer",
  },
  saveButton: {
    width: "100%",
    backgroundColor: "#000000",
    color: "#ffffff",
    borderRadius: "5px",
    fontSize: "small",
    marginTop: "10px",
    padding: "15px 0",
    border: "none",
    cursor: "pointer",
  },
  addNewActivityParent: {
    textAlign: "right",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "10px",
    padding: "10px 0",
  },
  addNewActivity: {
    border: "none",
    backgroundColor: "#fab005",
    cursor: "pointer",
    color: "#ffffff",
    fontSize: "25px",
    fontWeight: "bold",
    borderRadius: "3px",
    marginTop: "10px",
    "&:hover": {
      backgroundColor: "#f59f00",
    },
  },
  addInfo: {
    marginTop: "5px",
  },
  onLoadingDisable: {
    cursor: "not-allowed",
    backgroundColor: "#F6F6F6",
  },
  essentialSupportNumberBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "9px 13px",
    gap: "10px",
    borderRadius: "8px",
    background: "#FAFAFA",
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
    "& .mantine-Input-input": {
      textAlign: "center",
      color: "#262626",
      fontFamily: "Inter",
      fontSize: "16px",
      fontWeight: 400,
    },
  },

  reassessDatesContainer: {
    width: "100%",
    padding: "14px 12px",
    borderRadius: 12,
    border: "1px solid #E5E5EA",
    backgroundColor: "#FFF",
  },

  reassessDateLabel: {
    fontFamily: "Inter",
    fontSize: 13,
    fontWeight: 600,
    color: "#262626",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "10px",
    borderRadius: 8,
    border: "1px solid #D4D4D4",
    backgroundColor: "#FFF",
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05), 0 0 0 4px #F2F4F7",
  },

  // ********************** drawer styling *********************
  drawer: {
    "& .mantine-Drawer-content": {
      borderRadius: "16px",
      backgroundColor: "#F5F5F5",
    },
    "& .mantine-Drawer-body": {
      padding: "27px 27px 15px 27px !important",
    },
    "& .mantine-Drawer-header": {
      backgroundColor: "#FFF",
      padding: "19px 13px",
      // position: "sticky",
      // top: 0,
      // zIndex: 10,
      // borderBottom: "1px solid #E5E5E5",
    },
    "& .mantine-Drawer-title": {
      fontSize: "24px",
      fontWeight: "700",
      color: "#000",
      fontFamily: "Inter",
    },
  },
  dateRangePicker: {
    fontFamily: "Inter",
    "& .mantine-Input-wrapper": {
      marginTop: "6px",
      height: "auto",
      backgroundColor: "#FFFFFF",
      borderRadius: "8px",
      border: "1px solid #E5E5E5",
      boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",

      "& .mantine-DatePickerInput-input": {
        padding: "10px 14px",
      },
      "& .mantine-Input-input": {
        backgroundColor: "transparent",
        border: "none",
        height: "44px",
        color: "#262626",
        fontFamily: "Inter",
        fontSize: "14px",
        fontWeight: 600,
      },
    },
  },
  errorBorder: {
    "& .mantine-Input-wrapper": {
      border: "2px solid red",
    },
  },
  accordianParent: {
    borderRadius: "12px",
    border: "1px solid #E5E5EA",
    padding: "0px 13px",
    background: "#FFF",
  },
  accordion: {
    "& .mantine-Accordion-control": {
      borderBottom: "1px solid #E5E5E5",
      "& .display-on-close": {
        display: "none !important",
      },
      '&[aria-expanded="false"] .display-on-close': {
        display: "block !important",
      },
      '&[aria-expanded="true"] .display-on-close': {
        display: "none !important",
      },
    },
    "& .mantine-Accordion-content": {
      padding: "0px 0px 24px 0px",
      "& > .contentParent": {
        display: "flex",
        flexDirection: "column",
        gap: "24px",
        paddingTop: "24px",
      },
    },
    "& .mantine-Accordion-item:last-child": {
      borderBottom: "none",
    },
  },
  outcomeNumberInput: {
    width: "100%",
    "& .mantine-Input-input": {
      textAlign: "center",
      background: "transparent",
      color: "#262626",
      fontFamily: "Inter",
      fontSize: "16px",
      fontWeight: 400,
    },
    "& .mantine-Input-input:focus": {
      border: "none !important",
    },
    "& .mantine-Input-wrapper": {
      padding: "9px 13px",
      boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
      borderRadius: "8px",
      background: "#FAFAFA",
    },
    "& .mantine-Input-rightSection": {
      marginRight: "13px",
    },
    "& .mantine-Input-icon": {
      marginLeft: "13px",
      pointerEvents: "unset",
    },
    "& .mantine-InputWrapper-label": {
      color: "#262626",
      marginBottom: "6px",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: 500,
    },
  },
  inc_dec_Btn: {
    borderRadius: "50%",
    height: "26px",
    width: "26px",
    backgroundColor: "#FFF",
    filter: "drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.25))",
    padding: "0px",
    "&:hover": {
      backgroundColor: "#FFF",
    },
  },
  textArea: {
    "& .mantine-Input-wrapper": {
      height: "auto",
      backgroundColor: "#FFFFFF",
      borderRadius: "8px",
      border: "1px solid #E5E5E5",
      boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
      "& .mantine-Input-input": {
        fontFamily: "Inter",
        padding: "10px 14px",
        color: "#737373",
        fontSize: "12px",
        fontWeight: 400,
        height: "150px",
        borderRadius: "8px",
        background: "#FAFAFA",
      },
    },
    "& .mantine-InputWrapper-label": {
      color: "#262626",
      marginBottom: "6px",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: 500,
    },
  },
  checkboxGroup: {
    display: "flex",
    alignItems: "center",
    borderRadius: "8px",
    border: "1px solid #E5E5E5",
    background: "#FAFAFA",
    padding: "8px 0px 8px 14px",
    gap: 24,
    "& .mantine-Checkbox-body": {
      flexDirection: "column-reverse",
      gap: "4px",
    },
    "& .mantine-Checkbox-label": {
      padding: "0px",
      color: "#737373",
      fontFamily: "Inter",
      fontSize: "12px",
      fontWeight: 400,
    },
  },
  addNewActivityBtn: {
    width: "100%",
    backgroundColor: "#171717",
    borderRadius: "8px",
    fontWeight: 600,
    fontSize: "16px",
    fontFamily: "Inter",
    paddingBlock: "8px",
    height: "48px",
    "& .mantine-Button-label": {
      gap: 4,
    },
    "&:hover": {
      backgroundColor: "#171717",
    },
  },
  addAndSaveBtnParent: {
    display: "flex",
    padding: "24px 0px 12px 0px",
    borderTop: "1px solid #E5E5E5",
    background: "#FFF",
    alignItems: "center",
    gap: "16px",
    width: "100%",
    "& button": {
      borderRadius: "8px",
      paddingBlock: "16px",
      fontFamily: "Inter",
      height: "auto",
      fontSize: "18px",
      fontWeight: 600,
      boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
    },
    "& .addBtn": {
      flex: 1,
      color: "#262626",
      border: "1px solid #F5F5F5",
      background: "#F5F5F5",
    },
    "& .saveBtn": {
      flex: 1,
      borderRadius: "8px",
      border: "1px solid #FFAF4A",
      background: "#FFAF4A",
    },
  },
  profile_container: {
    borderRadius: "6px",
    border: "1px solid #E5E5EA",
    backgroundColor: "#FFF",
    padding: "12px 12px 20px 12px",
    marginBottom: "16px",
    "& .profileFlex": {
      marginBottom: "16px",
      paddingBottom: "16px",
      borderBottom: "1px solid #E7EBEF",
    },
    "& .img": {
      width: "68px",
      height: "68px",
      borderRadius: "50%",
      top: "0px !important",
    },

    "& .name": {
      marginBottom: "0px !important",
      marginTop: "0px",
      color: "#262626",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: 600,
    },

    "& .id": {
      marginTop: "0px",
      textTransform: "uppercase",
      color: "#737373",
      fontFamily: "Inter",
      fontSize: "12px",
      fontWeight: 400,
      marginBottom: "0px",
    },

    "& .label": {
      margin: "0px",
      color: "#737373",
      fontFamily: "Inter",
      fontSize: "12px",
      fontWeight: 400,
    },
  },
  editBtnBox: {
    height: "100%",
    width: "fit-content",
    "& button": {
      padding: "0px",
      height: "auto",
      "& .mantine-Button-label": {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "4px",
        fontFamily: "Inter",
        fontSize: "15px",
        fontWeight: 600,
        color: "#FFBA45",
      },
    },
  },

  // ************************* Effective Period Date Picker Styling ******************************

  buttonStyle: {
    fontFamily: "Inter",
    backgroundColor: "#FFFFFF",
    borderRadius: "8px",
    border: "1px solid #E5E5E5",
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
    height: "44px",
    padding: "10px 14px",
    color: "#262626",
    marginTop: "6px",
    width: "100%",
    "&:hover": {
      backgroundColor: "#FFFFFF",
    },
  },
  datePickerParent: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    "@media (max-width:834px)": {
      display: "block",
    },
  },
  popOverCard: {
    "@media (max-width:992px)": {
      left: "250px !important",
    },
    "@media (max-width:600px)": {
      left: "18px !important",
    },
    "@media (max-width:360px)": {
      left: "0px !important",
    },
  },
  buttonsParent: {
    borderRight: "1px solid #F5F5F5",
    display: "flex",
    flexDirection: "column",
    padding: "0 10px 0 0",
    "@media (max-width:834px)": {
      borderRight: "none",
    },
  },
  datePickerParentDiv: {
    // padding: "10px 0 10px 0",
  },
  datePicker: {
    padding: "0 10px 0 10px",
  },

  dateButtons: {
    width: "auto",
    marginTop: "12px",
    transition: "0.5s",
    backgroundColor: "transparent",
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: "#F5F5F5",
      color: "#262626",
    },
    color: "#000000",
    "@media (max-width:834px)": {
      backgroundColor: "#262626",
      color: "#F5F5F5",
    },
  },
  activeButton: {
    backgroundColor: "#000",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#000",
      color: "#fff",
    },
  },
  bottomButtonsParent: {
    borderTop: "1px solid #F5F5F5",
    paddingTop: "10px",
  },
  bottomButtons: {
    marginLeft: "15px",
  },
  cancelButton: {
    backgroundColor: "#F5F5F5",
    color: "#262626",
    "&:hover": {
      backgroundColor: "#F5F5F5",
    },
  },
  applyButton: {
    backgroundColor: "#262626",
    width: "55%",
    "&:hover": {
      backgroundColor: "#262626",
    },
  },
  iconCalendar: {
    margin: "0 10px 0 0",
  },
}));

export default useStyles;
